export default "__VITE_ASSET__40eab452__"